import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=3115c4ef&scoped=true"
import script from "./audit.vue?vue&type=script&lang=js"
export * from "./audit.vue?vue&type=script&lang=js"
import style0 from "./audit.vue?vue&type=style&index=0&id=3115c4ef&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115c4ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3115c4ef')) {
      api.createRecord('3115c4ef', component.options)
    } else {
      api.reload('3115c4ef', component.options)
    }
    module.hot.accept("./audit.vue?vue&type=template&id=3115c4ef&scoped=true", function () {
      api.rerender('3115c4ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchant/application/audit.vue"
export default component.exports